import { render, staticRenderFns } from "./form-select.vue?vue&type=template&id=5fd0e665&scoped=true"
import script from "./form-select.vue?vue&type=script&lang=js"
export * from "./form-select.vue?vue&type=script&lang=js"
import style0 from "./form-select.vue?vue&type=style&index=0&id=5fd0e665&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd0e665",
  null
  
)

export default component.exports